import React from 'react';
import './AboutSection.css';

const AboutSection = () => {
  return (
    <section id="about" className="about-section section-padding">
      <div className="container">
        <div className="about-content observe-fade">
          <div className="section-label">About Tara Ventures</div>
          <p className="about-text body-large">
            Tara Ventures is a Singapore-based venture firm working across three domains: <strong>Solar</strong>, developing small-scale deployments across South and Southeast Asia; <strong>Neural Interfaces</strong>, decoding brain signals to advance consciousness research; and <strong>Cultural Systems</strong>, structuring India's classical knowledge traditions for modern use.
          </p>
          <p className="about-text body-large">
            We build products through <strong>deep, multi-domain research</strong>, mapping physical, data, and economic constraints to create systems engineered to endure.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;